
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.998 10.278a2 2 0 00-2-2.001H33.21a2 2 0 01-2-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v43a2 2 0 002 2h35.972a2 2 0 002-1.998l.026-34.724z","fill":"#fff"}}),_c('path',{attrs:{"d":"M26.369 5.1H4.889v7.56h21.48V5.1z","fill":"#E4ECF7"}}),_c('path',{attrs:{"d":"M30.35.46l9.83 8.47h-8.87L30.35.46z","fill":"#91A1B6"}}),_c('path',{attrs:{"d":"M20.82 25.57a1.272 1.272 0 01.41.9 1 1 0 01-.41.91 1.27 1.27 0 01-.91.4 1.33 1.33 0 01-1.31-1.31 1.07 1.07 0 01.41-.9 1.198 1.198 0 011.81 0zM26.27 20.22H6.1a1.31 1.31 0 110-2.62h20.17a1.31 1.31 0 010 2.62zM26.27 23.95H6.1a1.31 1.31 0 010-2.62h20.17a1.34 1.34 0 011.22 1.818 1.27 1.27 0 01-1.22.802zM16.18 27.78H6.1a1.31 1.31 0 110-2.62h10.08a1.31 1.31 0 010 2.62z","fill":"#A6B7D4"}}),_c('path',{attrs:{"d":"M14.97 37.87H6.1a1.32 1.32 0 010-2.63h8.87a1.35 1.35 0 011.32 1.32 1.42 1.42 0 01-1.32 1.31zM14.97 41.64H6.1a1.31 1.31 0 110-2.62h8.87a1.34 1.34 0 011.32 1.31 1.42 1.42 0 01-1.32 1.31z","fill":"#91A1B6"}}),_c('path',{attrs:{"d":"M36.133 28.16a11.314 11.314 0 00-1.92-.2 10.69 10.69 0 000 21.37 12.51 12.51 0 001.92-.2 10.64 10.64 0 008.77-10.59 10.43 10.43 0 00-8.77-10.38z","fill":"#008C89"}}),_c('path',{attrs:{"d":"M31.613 37.845l1.61 1.612 4.794-4.848a2.256 2.256 0 013.125.084 2.298 2.298 0 01.071 3.153l-4.794 4.835-3.197 3.339-3.162-3.224-1.598-1.612a2.297 2.297 0 010-3.225 2.112 2.112 0 011.55-.771 2.093 2.093 0 011.6.657z","fill":"#fff"}})])
          )
        }
      }
    